import { createSelector } from '@reduxjs/toolkit'
import memoize from 'lodash/memoize'

const rootSelector = ({ gptPrompts }) => gptPrompts

export const gptPromptsSelector = createSelector(
  [rootSelector],
  ({ gptPrompts }) => gptPrompts
)

export const isLoadedSelector = createSelector(
  [rootSelector],
  ({ isLoaded }) => isLoaded
)

export const isLoadingSelector = createSelector(
  [rootSelector],
  ({ isLoading }) => isLoading
)

export const gptPromptByIdSelector = createSelector(
  gptPromptsSelector,
  (prompts) =>
    memoize((id) => prompts.find((prompt) => prompt.id === id))
)
